"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTimerMessageGenerator = void 0;
var _react = require("react");
var _conditionalAttributes = require("../conditionalAttributes/conditionalAttributes");
var _formatters = require("../formatter/formatters");
const {
  URGENCY_TAG_TYPE,
  DEFAULT_TIMER_META_CONFIG
} = require('../constants/constants').default;
const useTimerMessageGenerator = props => {
  const {
    timerType,
    startTime,
    endTime,
    timerMeta: incomingTimerMeta
  } = props;
  const [label, setLabel] = (0, _react.useState)('');
  const timerMeta = {
    ...(0, _conditionalAttributes.conditionalAttributes)(DEFAULT_TIMER_META_CONFIG),
    ...(0, _conditionalAttributes.conditionalAttributes)(incomingTimerMeta)
  };
  let startDate = new Date(startTime);
  let endDate = new Date(endTime);
  let currentDate = new Date().getDate();
  const timeOptions = {
    hour: 'numeric',
    minute: '2-digit'
  };
  const monthOptions = {
    day: 'numeric',
    month: 'long'
  };
  const formattedEndTimeValue = (0, _formatters.timeFormatter)(endDate, timeOptions);
  (0, _react.useEffect)(() => {
    let intervalId = setInterval(() => {
      switch (timerType) {
        case URGENCY_TAG_TYPE.THREE_PLUS_DAYS:
          if (currentDate === endDate.getDate() - 1) {
            setLabel(timerMeta.endsTomorrowLabel.replace('%1', formattedEndTimeValue));
          } else if (currentDate === endDate.getDate()) {
            setLabel(timerMeta.endsTodayLabel.replace('%1', formattedEndTimeValue));
          } else {
            setLabel(startDate.toLocaleString('en-US', monthOptions) + ' - ' + endDate.toLocaleString('en-us', monthOptions));
          }
          break;
        case URGENCY_TAG_TYPE.TWO_DAYS:
          if (currentDate === endDate.getDate()) {
            setLabel(timerMeta.endsTodayLabel.replace('%1', (0, _formatters.timeFormatter)(endDate, timeOptions)));
          } else {
            setLabel(timerMeta.todayAndTomorrowLabel);
          }
          break;
        case URGENCY_TAG_TYPE.ONE_DAY:
          setLabel(timerMeta.todayOnlyLabel.replace('%1', formattedEndTimeValue));
          break;
        case URGENCY_TAG_TYPE.HOURS:
          setLabel(timerMeta.hoursLabel.replace('%1', (0, _formatters.calculateHours)(endDate, startDate)) + ' | ' + (0, _formatters.timeFormatter)(startDate, {
            hour: 'numeric'
          }) + ' - ' + (0, _formatters.timeFormatter)(endDate, {
            hour: 'numeric'
          }));
          break;
        case URGENCY_TAG_TYPE.EXTENDED:
          setLabel(timerMeta.extendedLabel.replace('%1', (0, _formatters.timeFormatter)(endDate, {
            hour: 'numeric'
          })));
          break;
        case URGENCY_TAG_TYPE.UPCOMING:
          setLabel(timerMeta.comingSoonLabel);
          break;
        case URGENCY_TAG_TYPE.TIMER:
          const label = (0, _formatters.calculateTimer)({
            endDate,
            timerMeta,
            monthOptions,
            timeOptions
          });
          if (label === timerMeta.offerEndedLabel) {
            clearInterval(intervalId);
          }
          setLabel(label);
          break;
      }
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, [props]);
  return label;
};
exports.useTimerMessageGenerator = useTimerMessageGenerator;